"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.weeklyHoursAssignmentInputSchema = exports.weeklyHoursAssignmentSchema = exports.employeeInputSchema = exports.employeeSchema = void 0;
const zod_1 = require("zod");
const common_js_1 = require("./common.js");
const organisation_js_1 = require("./organisation.js");
exports.employeeSchema = zod_1.z.strictObject({
    id: common_js_1.idSchema,
    tenantId: organisation_js_1.tenantSchema.shape.id,
    name: common_js_1.textSchema,
    companyId: common_js_1.idSchema,
    fachgruppeId: common_js_1.idSchema,
    startsOn: common_js_1.dateSchema.nullable(),
    endsOn: common_js_1.dateSchema.nullable(),
    isActive: zod_1.z.boolean(),
});
exports.employeeInputSchema = zod_1.z.strictObject({
    name: common_js_1.textSchema,
    companyId: common_js_1.idSchema,
    fachgruppeId: common_js_1.idSchema,
    startsOn: common_js_1.dateSchema.optional(),
    endsOn: common_js_1.dateSchema.optional(),
});
/** Weekly target hours change from an effective date; old weeks retain their value. */
exports.weeklyHoursAssignmentSchema = zod_1.z.strictObject({
    id: common_js_1.idSchema,
    tenantId: organisation_js_1.tenantSchema.shape.id,
    employeeId: common_js_1.idSchema,
    effectiveFrom: common_js_1.dateSchema,
    hours: common_js_1.hoursSchema,
});
exports.weeklyHoursAssignmentInputSchema = exports.weeklyHoursAssignmentSchema.pick({
    employeeId: true,
    effectiveFrom: true,
    hours: true,
});
//# sourceMappingURL=employees.js.map